export const SOCKET_LINK = process.env.REACT_APP_SOCKET_LINK;
export const S3_BASE_URL = process.env.REACT_APP_S3_BASE || "https://tw-artifacts-center.s3.ap-southeast-1.amazonaws.com";

export const BASE_PATH = ""

const ORIGIN =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_FE_ORIGIN
    : window.location.origin.replace("www.", "") || "https://4wicket.com";
export const APP_ORIGIN = ORIGIN?.replace("ag.", "")?.replace("admin.", "");

export const DEBUG_SOCKET = false;

export const socketOptions = {
  transports: ["websocket", "polling"], // IMPORTANT
  reconnection: true,
  reconnectionAttempts: 20,
  forceNew: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  withCredentials: true,
  // autoConnect: false,
};

export const EVENTSTATUS = {
  INPLAY: "IN_PLAY",
  UPCOMING: "UPCOMING",
  SUSPENDED: "SUSPENDED",
  CLOSED: "CLOSED",
};

export const RUNNERSTATUS = {
  SUSPENDED: "SUSPENDED",
  BALLRUNNING: "BALL_RUNNING",
};
